import { render, staticRenderFns } from "./BuildingServiceModal.vue?vue&type=template&id=d434fdf8&"
import script from "./BuildingServiceModal.vue?vue&type=script&lang=ts&"
export * from "./BuildingServiceModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d434fdf8')) {
      api.createRecord('d434fdf8', component.options)
    } else {
      api.reload('d434fdf8', component.options)
    }
    module.hot.accept("./BuildingServiceModal.vue?vue&type=template&id=d434fdf8&", function () {
      api.rerender('d434fdf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/building/components/BuildingServiceModal.vue"
export default component.exports